exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host .container-fuild{display:flex;flex-wrap:nowrap;color:#a00313;background-color:#fcefef}:host .exclamation-icon{margin:1.5rem}:host .info{margin-top:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/shared/components/trc-admin-config/trc-admin-config.component.scss
// module id = 750
// module chunks = 0